import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { DocumentReadResponseModel } from 'src/app/models/api.model'
import { DocumentService } from '../common/document.service'
import { HttpHeaders } from '@angular/common/http'

@Injectable({ providedIn: 'root' })
export class Form11Service {
  constructor(private webService: WebService, private documentService: DocumentService) {}

  invokeForm11UploadAndReadAPI(
    aadhaarFront: File,
    aadhaarBack: File,
    pan: File,
    id: string
  ): Observable<DocumentReadResponseModel[]> {
    const endPoint = `${ServiceUrlConstants.API_EMPLOYEE_GENERATE_FORM11_READ_UPLOAD}/${id}`
    const formData: FormData = new FormData()
    formData.append('aadhaarFront', aadhaarFront)
    formData.append('aadhaarBack', aadhaarBack)
    formData.append('pan', pan)
    return this.webService
      .post(endPoint, formData, null, [], false)
      .pipe(map((response: DocumentReadResponseModel[]) => response))
  }

  invokeUpdateReferenceDetailsAPI(
    details: any,
    passportFile: File,
    passbook: File,
    pfServiceHistoryScreenshot: File,
    id: string
  ) {
    const endPoint = `${ServiceUrlConstants.API_UPDATE_REFERENCE_DETAILS}/${id}`
    const formData: FormData = new FormData()
    const blob = new Blob([JSON.stringify(details)], { type: 'application/json' })

    formData.append('referenceDetails', blob)
    if (passportFile) {
      const newFile = this.createNewFile(passportFile, '_passport')
      formData.append('passport', newFile)
    }
    if (passbook) {
      const newFile = this.createNewFile(passbook, '_passbook')
      formData.append('passbook', newFile)
    }
    if (pfServiceHistoryScreenshot) {
      const newFile = this.createNewFile(pfServiceHistoryScreenshot, '_pfServiceHistoryScreenshot')
      formData.append('pfServiceHistoryScreenshot', newFile)
    }
    return this.webService.put(endPoint, formData, null, [], false)
  }

  invokeDownloadForm11API() {
    const endPoint = ServiceUrlConstants.API_DOWNLOAD_FORM11
    this.documentService.downloadDocument(endPoint, {
      requestBody: {},
      queryParams: []
    })
  }

  invokeUploadForm11API(activtityId: string, form11File: File) {
    const endPoint = `${ServiceUrlConstants.API_UPLOAD_FORM11.replace(
      ServiceUrlConstants.PATH_VAR_TYPE_ACTIVITY_ID,
      activtityId
    )}`
    const formData = new FormData()
    formData.append('document', form11File)
    const headers = new HttpHeaders()
    headers.append('Content-Type', 'multipart/form-data')
    return this.webService.uploadDocument(endPoint, formData, headers).pipe(map((data: any) => data))
  }

  createNewFile(file: File, suffix: string) {
    const nameSplits = file.name.split('.')
    const extension = nameSplits.pop()
    const baseName = nameSplits.join('.')

    const newFileName = `${baseName}${suffix}.${extension}`
    return new File([file], newFileName, { type: file.type })
  }
}
